import React from 'react'
import PropTypes from 'prop-types'
import './button3d.scss'
import Spinner from '../Spinner'

const Button3d = ({
  className,
  style,
  label,
  onClick,
  isLoading,
  disabled,
  children,
  ...others
}) => (
  <button
    type="button"
    className={className}
    style={style}
    onClick={onClick}
    disabled={disabled || isLoading}
    {...others}
  >
    {isLoading ? (
      <Spinner color="white" isLoading />
    ) : (
      <span>
        {label}
        {children}
      </span>
    )}
  </button>
)

Button3d.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.object),
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
}

Button3d.defaultProps = {
  label: '',
  className: '',
  style: {},
  onClick: () => { },
  children: null,
  disabled: false,
  isLoading: false,
}

export default Button3d
